// extracted by mini-css-extract-plugin
export default {"root":"geaLW4","listContentColor":"qHsxWL","activeColor":"T8B1Is","icon":"c7xyET","reversedIcon":"aY7E_P"};